import { render, staticRenderFns } from "./tag_summary.vue?vue&type=template&id=3a4fa938&scoped=true"
import script from "./tag_summary.vue?vue&type=script&lang=js"
export * from "./tag_summary.vue?vue&type=script&lang=js"
import style0 from "./tag_summary.vue?vue&type=style&index=0&id=3a4fa938&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4fa938",
  null
  
)

export default component.exports